define('utils/wrapper',['underscore'], function(_){

  return function(fn){
    if (fn && fn.hasOwnProperty('hasCallback')){
      return fn;
    }
    var newFn;
    if (_.isFunction(fn)) {
      // res is from easyXDM and is a string
      newFn = function(res){
        var new_res = res;
        if (!res){
          new_res = null;
        }
        if (_.isString(res)) {
          try{
            new_res = JSON.parse(res);
          }catch(e){
            if (window.console) {
              console.log(e);
              console.log(res);
            }
          }
        }
        // call the original function provided by the user
        return fn(new_res);
      }
      newFn.hasCallback = true;
    }
    else {
      newFn = function(){ return null;};
      newFn.hasCallback = false;
    }
    return newFn;
  }
})
;
